module.exports = __webpack_public_path__ + "static/media/arrow-back.f1b97632.svg";